import { UniformSlot } from '@uniformdev/canvas-react';

import {
	ChevronColors,
	Expand,
	ExpandProps,
} from '@/libraries/design/components/expand/src/expand';
import { RichTextComponent } from '@/libraries/design/utils';

interface UniformExpandProps {
	eventDataName?: string;
	chevronColor?: ChevronColors;
	boldLabel?: boolean;
	label: string;
	richText?: string;
	expandedLabelText?: string;
}

const UniformExpand = (props: UniformExpandProps) => {
	const expandProps: ExpandProps = {
		eventDataName: props.eventDataName ?? undefined,
		chevronColor: props.chevronColor,
		boldLabel: props.richText ? false : props.boldLabel,
		label: props.richText ? <RichTextComponent text={props.richText} /> : props.label,
		expandedLabelText: props.expandedLabelText ?? null,
	};
	return (
		<Expand {...expandProps}>
			<UniformSlot name="contents" />
		</Expand>
	);
};

export default UniformExpand;
